// TO-DO 项目签报pc端页面审核逻辑与通用的审核逻辑不一致，所以该页面的审核未处理
// 黄工TODO 相关记录点击后显示不出数据，和后端联调一下
// http://localhost:8080/#/todoDetail?title=%E9%A1%B9%E7%9B%AE%E7%AD%BE%E6%8A%A5&target=xiangMuQianBao&id=889c0238-9043-4c68-8354-c393670330c4
const config = [
  {
    component: 'ZlmTitle',
    options: {
      size: 'medium',
      text: '计划信息',
    },
  },
  {
    component: 'ZlmNormalDetail',
    options: {
      data: {},
    },
  },
  {
    component: 'ZlmTitle',
    options: {
      size: 'medium',
      text: '采购文件',
    },
  },
  {
    component: 'file-list',
    options: {
      groupId: '',
    },
  },
  {
    component: 'ZlmTitle',
    options: {
      size: 'medium',
      text: '计划附件',
    },
  },
  {
    component: 'file-list',
    options: {
      groupId: '',
    },
  },
  {
    component: 'ZlmTitle',
    options: {
      size: 'medium',
      text: '招标组织方式',
    },
  },
  {
    component: 'ZlmNormalDetail',
    options: {
      data: {},
    },
  },
  {
    component: 'ZlmTitle',
    options: {
      size: 'medium',
      text: '备案信息',
    },
  },
  {
    component: 'ZlmNormalDetail',
    options: {
      data: {},
    },
  },
  {
    component: 'ZlmTitle',
    options: {
      size: 'medium',
      text: '备案审核流程',
    },
  },
  {
    component: 'ZlmTabDetail',
    options: {
      title: '流程',
      data: [], // 11
    },
  },

]

const { getProjectTypeName } = require('../projectType')
const { getPurchaseTypeName } = require('../purchaseType')
const Common = require('@/lib/common').default

const mixin = {
  data() {
    return {
      config: JSON.parse(JSON.stringify(config)),
      needOpinion: true,
    }
  },
  methods: {
    getData() {
      this.getBaseInfo()
    },
    getBaseInfo() {
      const guid = this.$route.query.id
      this.$request
        .post(
          `/transformToAfter/app/project/signBeiAn/getQianBaoBeiAnDetail`,
          {
            guid: guid,
          },
          { showLoading: true },
        )
        .then((res) => {
          this.config[3].options.groupId = res.data.scFile
          this.config[5].options.groupId = res.data.jiHuaFuJian
          this.config[1].options.data = {
            采购计划名称: res.data.projectName,
            采购计划编号: res.data.planNo,
            计划招标时间: this.$util.timeFormatter(
              res.data.planProcurementTime,
            ),
            计划开工时间: this.$util.timeFormatter(
              res.data.startOrDeliveryTime,
            ),
            计划所属单位: res.data.caiGouPlanReport.tibaoDepartment,
            '项目估算（万元）': res.data.estimatedAmount,
            '工期/服务期（月）': this.getPlanSchedule(res.data.caiGouPlanReport),
            项目性质: res.data.caiGouPlanReport.xiangmuXingzhi === 1 ? '预算投资采购' : '承接项目分包采购',
            行业: this.getHangYe(res.data.hangYe),
            采购类型: this.getCaiGouType(res.data.zbCaigouLiexingChoose),
            项目计划级别: res.data.jiHuaJiBie === 1 ? '一般项目' : '重大项目',
            计划类型: res.data.ifJicaijihua === 0 ? '单项计划' : '预集采计划',
            类别: getProjectTypeName(res.data.projectType),
            项目概况: res.data.remark,
            采购计划变更说明: res.data.caiGouPlanReport.chongxinTiJiaoExplain,
          }
          if (res.data.zbCaigouLiexingChoose === '5') {
            this.config[1].options.data = {
              ...this.config[1].options.data,
              商城采集: res.data.caiGouPlanReport.isShop === 1 ? '是' : '否',
              邀请单位: res.data.caiGouPlanReport.yaoqingDanwei,
            }
          }
          if (!res.data.caiGouPlanReport.chongxinTiJiaoExplain) {
            delete this.config[1].options.data.采购计划变更说明
          }
          if (res.data.zhiXingFangShi === 3) {
            this.config[7].options.data = {
              执行方式: this.getZhiXingFangShi(res.data.zhiXingFangShi),
            }
          } else {
            this.config[7].options.data = {
              执行方式: this.getZhiXingFangShi(res.data.zhiXingFangShi),
              执行单位: res.data.zhiXingDanWei,
              计划执行人: res.data.zhiXingRen,
              执行人联系方式: res.data.zhiXingLianXiFangShi,
            }
          }
          this.config[9].options.data = {
            招标采购方式: getPurchaseTypeName(res.data.purchaseType),
            资审方式: Common.zsFangShi[res.data.zsFangshi.toString()],
            // 竞谈方式: res.data.supplierSource === 1 ? '公开' : '邀请',
            // 询比方式: res.data.supplierSource === 1 ? '公开' : '邀请',
            // 竞价方式: res.data.supplierSource === 1 ? '公开' : '邀请',
            是否进场: res.data.isJinChang === 0 ? '不进场' : '进场',
            是否备案: res.data.isBeiAn === 0 ? '不备案' : '备案',
            签报内容: this.getQianBaoNeiRong(res.data.qianBaoNeiRong),
            项目计划级别: this.getProjectJiBie(res.data.jiHuaJiBie),
            招标组织形式: this.getZhuZhiXingShi(res.data.zuZhiXingShi),
            评标办法: this.getPbFangFa(res.data.bdList[0].pbBanFa),
            主要资格条件: res.data.bdList[0].zbRequire,
            项目签报变更说明: res.data.chongxinTiJiaoExplain,
          }
          if (!res.data.chongxinTiJiaoExplain) {
            delete this.config[9].options.data.项目签报变更说明
          }
          this.config[11].options.data = res.data.shenherenList.map(
            (t) => ({
              审核级别: t.level,
              审核人员: t.userName,
              职务: t.job,
              单位部门: t.qiyeName + '--' + t.deptName,
            }),
          )
        })
    },
    // 行业 1、交通运输 2、房地产 3、金融
    getHangYe(type) {
      let result = '交通运输'
      switch (type) {
        case 1:
          result = '交通运输'
          break
        case 2:
          result = '房地产'
          break
        case 3:
          result = '金融'
          break
        default:
          break
      }
      return result
    },
    // 采购方式    公开招标 1 邀请招标 2 询比采购 3 谈判采购 4 直接采购5 竞价6
    getCaiGouType(type) {
      let result = '公开招标'
      switch (type) {
        case '1':
          result = '公开招标'
          break
        case '2':
          result = '邀请招标'
          break
        case '3':
          result = '询比采购'
          break
        case '4':
          result = '谈判采购'
          break
        case '5':
          result = '直接采购'
          break
        case '6':
          result = '竞价'
          break
        default:
          break
      }
      return result
    },
    getAuditList() {
      this.$request
        .post(
          `/transformToAfter/app/project/signBeiAn/getRecord`,
          {
            guid: this.$route.query.id,
            businessType: 70,
          },
        )
        .then((res) => {
          if (res.data && res.data.length > 0) {
            this.config[13].options.data = res.data.map(
              (t) => ({
                提交人: t.submitter,
                提交时间: this.$util.timeFormatter(t.submitTime),
                审批人: t.auditName,
                职务: t.job,
                审批结果: this.getShenHeJieGuo(t.statusMsg),
                审核时间: this.$util.timeFormatter(t.auditTime),
                审批意见: t.auditOpinion,
              }),
            )
          }
        })
    },
    // 审核结果
    getShenHeJieGuo(type) {
      let result = ''
      switch (type) {
        case 0:
          result = '未审批'
          break
        case 1:
          result = '审批通过'
          break
        case 2:
          result = '审批驳回'
          break
        case 3:
          result = '流程撤回'
          break
        default:
          break
      }
      return result
    },
    pass(opinion) {
      // this.commit()
      this.projectFilingCommit({
        opinion: opinion,
      })
    },
    fail(opinion) {
      this.projectFilingCommit({
        status: 2, // 不通过
        opinion: opinion,
      })
      // this.commit({
      //     opValue: '2', // 不通过
      //     opinion: opinion,
      // })
      // this.failedCommit({
      //   opValue: '2', // 不通过
      //   opinion: opinion,
      // })
    },
    // 评标办法 1-合理低价法，2-综合评估法，3-综合评分法，4-经评审的最低投标价法，5-技术评分最低标价法，null-不限（默认）
    getPbFangFa(type) {
      let result = '招标文件和限价'
      switch (type) {
        case 1:
          result = '合理低价法'
          break
        case 2:
          result = '综合评估法'
          break
        case 3:
          result = '综合评分法'
          break
        case 4:
          result = '经评审的最低投标价法'
          break
        case 5:
          result = '技术评分最低标价法'
          break
        default:
          break
      }
      return result
    },
    getPlanSchedule(data) {
      // 工期不存在时，直接返回空字符
      if (!data.gongQi) {
        return ''
      }
      return (
        (data.gongQi ? data.gongQi : '') +
        (data.gongQiUnit ? data.gongQiUnit : '月')
      )
    },
    // 签报内容 1:招标文件和限价2：招标文件3：限价文件
    getQianBaoNeiRong(type) {
      let result = '招标文件和限价'
      switch (type) {
        case 1:
          result = '招标文件和限价'
          break
        case 2:
          result = '招标文件'
          break
        case 3:
          result = '限价文件'
          break
        default:
          break
      }

      return result
    },
    // 项目计划级别 1:一般项目2：重大项目3：无
    getProjectJiBie(type) {
      let result = '一般项目'
      switch (type) {
        case 1:
          result = '一般项目'
          break
        case 2:
          result = '重大项目'
          break
        case 3:
          result = '无'
          break
        default:
          break
      }
      return result
    },
    getZhuZhiXingShi(type) {
      let result = '自行执行'
      switch (type) {
        case 1:
          result = '自行执行'
          break
        case 2:
          result = '代理执行'
          break
        default:
          break
      }
      return result
    },
    // 执行方式 1:提交集团部门/单位执行2：委托代理机构执行3：自行执行
    getZhiXingFangShi(type) {
      let result = '提交集团部门/单位执行'
      switch (type) {
        case 1:
          result = '提交集团部门/单位执行'
          break
        case 2:
          result = '委托代理机构执行'
          break
        case 3:
          result = '自行执行'
          break
        default:
          break
      }
      return result
    },
  },
}

module.exports = {
  config,
  mixin,
}
